export default __webpack_public_path__ + "static/media/ic_loader.5a92083c.svg";